import { isDateCurrentYear } from '../validator/is-date-current-year'
import { isDateToday } from '../validator/is-date-today'

/**
 * This function distinguishes between this year, today and others.
 * If it is today it will just return the time formatted.
 * If it is the current year, it will returned without the year.
 * If `preserveDate` is true the date will always be included.
 *
 * To keep the function performant there is no type checking like 'date instanceof Date' or 'moment(date).isValid()'.
 * If you aren't sure about the arguments you pass to this function please validate them beforehand.
 *
 * @param {Intl} intl                       - Global Modux intl helper.
 * @param {string} iso8601string            - The date to be parsed as ISO-8601 compliant string with time zone.
 * @param {boolean} [preserveDate=false]    - If true it always returns with date even its today.
 * @param {boolean} [useUTC=false]          - If true the date is used as a UTC time
 * @returns {string|null} Returns a string with the formatted date and time or null
 */
export function formatDateWithSeconds(intl, iso8601string, preserveDate = false, useUTC = false) {
    if (!iso8601string) {
        return null
    }
    const date = new Date(iso8601string)

    if (preserveDate || !isDateToday(date)) {
        if (useUTC) {
            return intl.formatDate(
                date,
                isDateCurrentYear(date) ? 'shortDateFullTimeWoYearUTC' : 'shortDateFullTimeUTC'
            )
        }
        return intl.formatDate(date, isDateCurrentYear(date) ? 'shortDateFullTimeWoYear' : 'shortDateFullTime')
    } else {
        if (useUTC) {
            return intl.formatFullTimeOnlyUTC(date)
        }
        return intl.formatFullTimeOnly(date)
    }
}
